import styled from '@emotion/styled'
import { MediaQueries } from '@hhgtech/hhg-components/misc'

type StyledBannerContainerProps = {
  enableScroll?: boolean
}
export const StyledBannerContainer = styled.a<StyledBannerContainerProps>`
  position: relative;
  display: block;
  text-decoration: none;
  img {
    ${MediaQueries.mbUp} {
      aspect-ratio: 1920 / 550;
      width: 100%;
      height: auto;
      object-fit: cover;
      object-position: center;
    }
    ${MediaQueries.mbDown} {
      width: 100%;
      height: auto;
    }
  }
`
